import axios from "axios";
import { deserialize, deserializeList, authCfg, parseCrmError } from "../crm/api";

// FT-076: общий (не-CRM) ресурс задач. Переиспользуем JSON:API-хелперы из crm/api,
// но бьём в плоский /api/v1/tasks (компания резолвится из current_user на бэке).
const BASE = "/api/v1";

// Кого можно назначать исполнителем: активные сотрудники staff-ролей
// (без agent/partner/guest — совпадает с backend-гейтом TasksController::STAFF_ROLES).
const ASSIGNABLE_ROLES = ["superadmin", "admin", "manager", "user"];

export { parseCrmError };

export default {
  list: (params) =>
    axios.get(`${BASE}/tasks`, authCfg({ params })).then((r) => ({
      items: deserializeList(r.data),
      meta: r.data.meta || {},
    })),
  create: (payload) =>
    axios.post(`${BASE}/tasks`, { task: payload }, authCfg()).then((r) => deserialize(r.data.data)),
  update: (id, payload) =>
    axios.patch(`${BASE}/tasks/${id}`, { task: payload }, authCfg()).then((r) => deserialize(r.data.data)),
  complete: (id) =>
    axios.post(`${BASE}/tasks/${id}/complete`, {}, authCfg()).then((r) => deserialize(r.data.data)),
  reopen: (id) =>
    axios.post(`${BASE}/tasks/${id}/reopen`, {}, authCfg()).then((r) => deserialize(r.data.data)),
  stopRecurrence: (id) =>
    axios.post(`${BASE}/tasks/${id}/stop_recurrence`, {}, authCfg()).then((r) => deserialize(r.data.data)),
  remove: (id) => axios.delete(`${BASE}/tasks/${id}`, authCfg()),
  // /tasks/users вместо /users: кассовый /users закрыт для роли user (403),
  // из-за чего у неё пустел селект исполнителя и не резолвились имена.
  // 404-fallback на старый /users — если FE выехал раньше api с новым эндпоинтом
  // (у роли user он ответит 403 — глотается вызывающим catch, как и раньше).
  users: () =>
    axios
      .get(`${BASE}/tasks/users`, authCfg())
      .catch((e) => {
        if (e.response && e.response.status === 404) return axios.get(`${BASE}/users`, authCfg());
        throw e;
      })
      .then((r) =>
      (r.data || [])
        .filter((u) => u.active !== false && ASSIGNABLE_ROLES.includes(u.role))
        .map((u) => ({ id: u.id, name: u.name || u.email || `#${u.id}` }))
    ),
};
